module.exports = __webpack_public_path__ + "img/18.70951707.jpg";